import styled from 'styled-components';

export const Checkmark = styled.span`
  position: absolute;
  left: 0;
  height: 16px;
  width: 16px;
  border: 1.5px ${({ theme }) => theme.border.style.solid}
    ${({ theme }) => theme.color.icon.neutral.default};
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.border.radius.small};

  &::after {
    content: '';

    position: absolute;
    display: none;
    left: 4px;
    width: 4px;
    height: 8px;
    border: ${({ theme }) => theme.border.style.solid}
      ${({ theme }) => theme.color.icon.neutral.default};
    border-width: 0 1.5px 1.5px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

export const Checkbox = styled.input`
  width: 0;
  height: 0;
  opacity: 0;
`;

export const Wrapper = styled.label`
  position: relative;
  margin-top: 4px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding-left: 28px;
  cursor: pointer;

  ${Checkbox}:checked ~ ${Checkmark}::after {
    border-color: ${({ theme }) => theme.color.background.brand.default};
    display: block;
  }

  ${Checkbox}:checked ~ ${Checkmark} {
    border-color: ${({ theme }) => theme.color.background.brand.default};
  }

  ${Checkbox}:disabled ~ ${Checkmark} {
    border-color: ${({ theme }) => theme.color.background.neutral.weak};
    cursor: not-allowed;
  }
`;
